import * as React from 'react'

interface OwnProps {
    error?: string | null
}

class TracepointFormHeader extends React.Component<OwnProps> {
    public render() {
        const { error } = this.props

        if (!error) {
            return null
        }

        return (
            <div className="alert alert-danger">
                <h4>
                    <i className="fa fa-warning" /> Error Processing Form
                </h4>
                <p>{error}</p>
            </div>
        )
    }
}
export default TracepointFormHeader
